import { useMemo } from 'react';
import {
    defaultExpanderButtonStyle,
    TransportAssignmentSidebarExpanderButtonStyle,
    unconfirmedExpanderButtonStyle,
} from '../buttonStyleAndSettings';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Button from '@rio-cloud/rio-uikit/Button';

const getActionButtonLabelId = (isUnconfirmed: boolean, isCapacity: boolean): string => {
    if (isUnconfirmed)
        return isCapacity
            ? 'outboundPortal.transportAssignments.button.confirmCapacity'
            : 'outboundPortal.transportAssignments.button.confirmOrder';
    return isCapacity
        ? 'outboundPortal.transportAssignments.button.updateCapacity'
        : 'outboundPortal.transportAssignments.button.update';
};

export type ConfirmationButtonProps = {
    isUnconfirmed: boolean;
    isCapacity: boolean;
    isLoading: boolean;
    isButtonDisabled: boolean;
    onConfirm: () => void;
};

export const ConfirmationButton = ({
    isUnconfirmed,
    isCapacity,
    isLoading,
    isButtonDisabled,
    onConfirm,
}: ConfirmationButtonProps) => {
    const { actionButtonStyles, actionButtonIconStyles } = useMemo<TransportAssignmentSidebarExpanderButtonStyle>(
        () => (isUnconfirmed ? unconfirmedExpanderButtonStyle : defaultExpanderButtonStyle),
        [isUnconfirmed],
    );

    return (
        <Button
            className={classNames(actionButtonStyles, isLoading ? 'btn-loading' : '')}
            onClick={onConfirm}
            disabled={isLoading || isButtonDisabled}
        >
            <span className={classNames(actionButtonIconStyles)} aria-hidden="true" />
            <FormattedMessage id={getActionButtonLabelId(isUnconfirmed, isCapacity)} />
        </Button>
    );
};
